import { EventEmitter } from 'events';
import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import { TEAM_EVENT_NAME } from '@/api/logical/im_team';
import { inWindow } from '@/config';
export class ImTeamManager {
    constructor() {
        this.teamList = [];
        this.eventName = 'IM_TEAM';
        this.eventEmitter = new EventEmitter();
        this.$niminstance = null;
        this.systemApi = masterApi.getSystemApi();
        this.eventApi = masterApi.getEventApi();
        this.targetDataWinId = '-1';
    }
    init($nimInstance) {
        this.$niminstance = $nimInstance;
        $nimInstance.subscrible('onUpdateTeam', async (params) => {
            await new Promise(resolve => {
                setTimeout(resolve, 100);
            });
            const teamInfo = await this.requestTeamInfo($nimInstance, params);
            this.sendTeamNotify2Datawin({
                action: TEAM_EVENT_NAME.UPDATE_TEAM,
                team: Object.assign(teamInfo, params),
            });
        });
        this.systemApi
            .getAllWindow()
            .then(list => {
            var _a;
            this.targetDataWinId = ((_a = list.find(item => item.type === 'bkStable')) === null || _a === void 0 ? void 0 : _a.webId) || '-1';
        })
            .catch(ex => {
            console.log('[im.team]init.getWindowsError:', ex);
        });
        $nimInstance.subscrible('onTransferTeam', (params) => {
            const { team, from, to } = params;
            const $index = this.teamList.findIndex(item => item.teamId === team.teamId);
            if ($index !== -1) {
                Object.assign(this.teamList[$index], params);
            }
            const accounts = [];
            const fromAccount = from.id.split('-')[1];
            const toAccount = to.id.split('-')[1];
            fromAccount && accounts.push(fromAccount);
            toAccount && accounts.push(toAccount);
            this.sendTeamNotify2Datawin({
                action: TEAM_EVENT_NAME.TRANSFER_TEAM,
                team,
                accounts,
            });
        });
        ['onAddTeamMembers', 'onRemoveTeamMembers'].forEach(key => {
            $nimInstance.subscrible(key, async (params) => {
                const { teamId } = params.team;
                const $index = this.teamList.findIndex(team => team.teamId === teamId);
                if ($index !== -1) {
                    Object.assign(this.teamList[$index], params);
                }
                const curUser = this.getMyAccount();
                if (key === 'onRemoveTeamMembers' && params.accounts.includes(curUser)) {
                    this.sendTeamNotify2Datawin({
                        action: TEAM_EVENT_NAME.LEAVE_TEAM,
                        team: params.team,
                    });
                }
                else if (key === 'onAddTeamMembers' && params.accounts.includes(curUser)) {
                    const teamInfo = await this.requestTeamInfo($nimInstance, params.team);
                    this.sendTeamNotify2Datawin({
                        action: TEAM_EVENT_NAME.JOIN_TEAM,
                        team: teamInfo,
                    });
                }
                else {
                    this.sendTeamNotify2Datawin({
                        action: key === 'onRemoveTeamMembers' ? TEAM_EVENT_NAME.REMOVE_TEAM_MEMBERS : TEAM_EVENT_NAME.ADD_TEAM_MEMBERS,
                        team: params.team,
                        accounts: params.accounts,
                    });
                }
            });
        });
        $nimInstance.subscrible('onDismissTeam', (params) => {
            const { teamId } = params;
            const $index = this.teamList.findIndex(team => team.teamId === teamId);
            if ($index !== -1) {
                this.teamList.splice($index, 1);
            }
            this.sendTeamNotify2Datawin({
                action: TEAM_EVENT_NAME.LEAVE_TEAM,
                team: params,
            });
        });
    }
    async sendTeamNotify2Datawin(param) {
        var _a;
        if (this.targetDataWinId === '-1' && inWindow()) {
            const list = await this.systemApi.getAllWindow('bkStable');
            this.targetDataWinId = ((_a = list.find(item => item.type === 'bkStable')) === null || _a === void 0 ? void 0 : _a.webId) || '-1';
        }
        this.eventApi.sendSysEvent({
            eventName: 'imTeamEvents',
            eventStrData: param.action,
            eventData: param,
            eventTarget: `${this.targetDataWinId}`,
        });
    }
    getMyAccount() {
        const contactInfo = this.systemApi.getCurrentUser();
        const $index = lodashGet(contactInfo, 'contact.contactInfo', []).findIndex(item => item.contactItemType === 'yunxin');
        return lodashGet(contactInfo, `contact.contactInfo[${$index}].contactItemVal`, '');
    }
    subscrible(callback) {
        this.eventEmitter.on(this.eventName, callback);
    }
    async requestTeamInfo($instance, teamInfo) {
        const { teamId } = teamInfo;
        const $index = this.teamList.findIndex(team => team.teamId === teamId);
        if ($index !== -1) {
            this.teamList[$index] = Object.assign(this.teamList[$index], teamInfo);
            return this.teamList[$index];
        }
        const remoteTeamInfo = (await $instance.excute('getTeam', {
            teamId,
        }));
        this.teamList.push(remoteTeamInfo);
        return remoteTeamInfo;
    }
    _sleep(serial = 0) {
        return new Promise(resolve => {
            setTimeout(resolve, serial * 60 * 1000);
        });
    }
    async getTeamMembersByIds(ids) {
        console.log('[teamManage] getTeamMembersByIds', ids);
        const _ids = ids
            .filter(item => item.length && /\d+/.test(item))
            .reduce((total, cur) => {
            if (!Array.isArray(total[total.length - 1]) || total[total.length - 1].length >= ImTeamManager.MAX_CALL_FREQ) {
                total.push([]);
            }
            const _subArr = total[total.length - 1];
            _subArr.push(cur);
            return total;
        }, []);
        const results = await Promise.all(_ids.map(async (subIds, index) => {
            await this._sleep(index);
            return this._getTeamMembers(subIds);
        }));
        return results.reduce((total, cur) => total.concat(cur), []);
    }
    async _getTeamMembers(ids) {
        return Promise.all(ids.map(id => {
            var _a;
            return (_a = this.$niminstance) === null || _a === void 0 ? void 0 : _a.excute('getTeamMembers', {
                teamId: id,
            });
        }));
    }
}
ImTeamManager.MAX_CALL_FREQ = 30;
